import React from 'react';
import PropTypes from 'prop-types';
import LocationIcon from '../../../../../icons/icon-location.svg';
import CloseX from '../../../../../icons/icon-close-modal.svg';
import isEnterOrSpace from '../../../../../helpers/isEnterOrSpace';


const ModalHeader = function ModalHeader({ upperTitle, title, action }) {
  return (
    <div className="opco-nav-header__container">
      <span className="opco-nav-header__upper">
        <LocationIcon className="opco-nav-header__location-icon" />
        <span className="opco-nav-header__upper-title">
          {upperTitle}
        </span>
        <button
          type="button"
          tabIndex="0"
          aria-label="Close"
          className="opco-navigator__modal-close"
          onClick={() => action()}
          onKeyPress={event => isEnterOrSpace(event) && action()}
        >
          <CloseX className="opco-navigator__modal-close--icon" />
        </button>
      </span>
      <div className="opco-nav-header__title">
        {title}
      </div>
    </div>
  );
};

ModalHeader.propTypes = {
  upperTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

export default ModalHeader;
